<script lang="ts" setup>
import { TheResponsiveNavbar, TheSnackbar } from '@/components';
import { useRoute } from 'vue-router';

const route = useRoute();

const isCenterOnMobile = computed((): boolean => {
  return [
    'account-account-settings-update-password',
    'account-help-centre-report-a-problem',
    'account-company-profile',
  ].includes(route.name as string);
});
</script>
<template>
  <v-layout>
    <v-main
      class="simple-layout page-background"
      :class="{
        'simple-layout--center-on-mobile': isCenterOnMobile,
      }"
    >
      <TheResponsiveNavbar />
      <v-container fluid class="simple-layout__border d-flex align-center justify-center pa-0">
        <NuxtPage :page-key="(route) => route.fullPath" class="simple-layout__page" />
      </v-container>
    </v-main>
    <TheSnackbar />
  </v-layout>
</template>
<style lang="scss" scoped>
.simple-layout {
  min-height: 100vh;

  &__border {
  }
}

@media (max-width: 768px) {
  .simple-layout {
    --v-layout-top: 0px !important;
  }

  .simple-layout.simple-layout--center-on-mobile {
    display: flex;
    flex-direction: column;

    .simple-layout__border {
      flex-grow: 1;

      > * {
        height: 100%;
        padding-top: 20px;
      }
    }
  }
}
</style>
